import ArtistService from '../services/artistService';
import urls from '../constants/urls.js';
import trimStart from 'lodash/trimStart';

export function readImage(event, onloadCallback, fileSizeExceededCallback, fileSizeLimitMB = 2) {
    const reader = new FileReader();
    reader.onload = onloadCallback;
    const file = event.target.files[0];
    const fileSizeMB = file.size/1024/1024;
    if(fileSizeMB > fileSizeLimitMB) {
        if(fileSizeExceededCallback) {
            fileSizeExceededCallback(`The file selected is too big, please upload a file under ${fileSizeLimitMB}MB`);
        }
    }
    else if(/\.(jpe?g|png|gif)$/i.test(file.name)) {
        reader.readAsDataURL(file);
    }  
}

export function getCroppedImage(image, pixelCrop) {
    const canvas = document.createElement('canvas');
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext('2d');
  
    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );
  
    // As Base64 string
    const base64Image = canvas.toDataURL('image/jpeg');
    return base64Image;
}

export function getThumbnail(imageUrl, roleType, params) {
    if(imageUrl) {
        return `${urls.USER_IMAGES_BASE_URL}${imageUrl}${params}`;
    }
    else {
        let defaultImage =  `${ArtistService.getDefaultImage(roleType)}`;
        if(defaultImage.indexOf('?') > -1) {
            defaultImage = `${defaultImage}&${trimStart(params, '?')}`;
        }
        else {
            defaultImage += params;
        }
        return defaultImage;
    }
}